import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import TabFieldsMaintenance from '@/components/TabFieldsMaintenance/TabFieldsMaintenance';
import { fieldsTabsToBackKey } from '@/helpers/constants';
import { urlToTabKey } from '@/helpers/utils';
import { setAffectedVehiclesForms } from '@/redux/Forms/forms.action';
import { ReduxForms } from '@/types';

type AffectedVehiclesFieldsMaintenanceProps = {
  setAffectedVehiclesFormsRedux: (forms: ReduxForms) => void;
};

const AffectedVehiclesFieldsMaintenance: React.FC<AffectedVehiclesFieldsMaintenanceProps> = (props) => {
  const { setAffectedVehiclesFormsRedux } = props;
  const tab = urlToTabKey(fieldsTabsToBackKey);
  const { t } = useTranslation();

  const formsTitles = {
    amgVehicles: t('affectedVehicles.amgVehicles'),
  };

  return (
    <TabFieldsMaintenance
      tab={tab}
      setStateRedux={setAffectedVehiclesFormsRedux}
      formsTitles={formsTitles}
    />
  );
};

const actionCreators = {
  setAffectedVehiclesFormsRedux: setAffectedVehiclesForms,
};

export default connect(null, actionCreators)(AffectedVehiclesFieldsMaintenance);
